import axios from 'axios';

axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('moder-token')}` || '';

axios.interceptors.response.use(undefined, (err) => {
  const res = err.response;

  if (res !== undefined) {
    if (res.status === 401) {
      console.log('Intercepted! 401 response handled!');
      localStorage.removeItem('moder-token');
      window.location.href = '/login';
    } else if (res.status === 403) {
      console.log('Intercepted! 403 response handled!');
      window.location.href = '/status-photo';
    }
  }

  return Promise.reject(err);
});

export default axios;



// WEBPACK FOOTER //
// ./src/utils/axios.js